import { render, staticRenderFns } from "./BaseWallow.vue?vue&type=template&id=9be686be&scoped=true&"
import script from "./BaseWallow.vue?vue&type=script&lang=js&"
export * from "./BaseWallow.vue?vue&type=script&lang=js&"
import style0 from "./BaseWallow.vue?vue&type=style&index=0&id=9be686be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be686be",
  null
  
)

export default component.exports